// Components
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

// Types
import { VisualAcuityChartRowType } from "src/services/exams/types";

type VisualAcuityIndexType = {
  chartRow: VisualAcuityChartRowType;
  index: number;
  isLiveUpdate?: boolean;
};

const VisualAcuityIndex = ({
  chartRow,
  index,
  isLiveUpdate = false,
}: VisualAcuityIndexType) => {
  // Smaller text on narrow screens in the live update view, matching
  // VisualAcuityScale.
  const fontSize = isLiveUpdate ? { xs: "11px", sm: "14px" } : "14px";

  return (
    <Grid
      container
      item
      display="flex"
      alignItems="center"
      xs={3}
      sx={{ minWidth: 0 }}
    >
      <Grid item xs={6} sx={{ minWidth: 0 }}>
        <Typography noWrap fontSize={fontSize} textAlign="center">
          {chartRow?.logMARVisualAcuityScale ?? "-"}
        </Typography>
      </Grid>
      <Grid item xs={6} sx={{ minWidth: 0 }}>
        <Typography noWrap fontSize={fontSize} textAlign="center">
          {index + 1}
        </Typography>
      </Grid>
    </Grid>
  );
};

export default VisualAcuityIndex;
